export default "__VITE_ASSET__uvIvnKEJ__"